// extracted by mini-css-extract-plugin
module.exports = {"root":"QuantitySelector_root__OIEWc","ctrl_btn":"QuantitySelector_ctrl_btn__v0y7i","input":"QuantitySelector_input__X9Mux"};